import React from "react";

// Shown while a lazily-loaded route chunk is fetched. Deliberately quiet: on a
// warm cache the chunk arrives in a few milliseconds, so a spinner would flash
// in and out. A calm centred mark reads better than a jolt of motion.
const RouteFallback = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Loading"
    style={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#fffbf2",
    }}
  >
    <span
      style={{
        width: 34,
        height: 34,
        borderRadius: "50%",
        border: "2px solid rgba(94,62,62,0.18)",
        borderTopColor: "#5e3e3e",
        display: "inline-block",
        animation: "routeFallbackSpin 0.7s linear infinite",
      }}
    />
    <style>{`
      @keyframes routeFallbackSpin { to { transform: rotate(360deg); } }
      @media (prefers-reduced-motion: reduce) {
        [aria-label="Loading"] > span { animation: none; }
      }
    `}</style>
  </div>
);

export default RouteFallback;
